import { render } from "./collapse.vue?vue&type=template&id=483c8282&scoped=true"
import script from "./collapse.vue?vue&type=script&lang=js"
export * from "./collapse.vue?vue&type=script&lang=js"

import "./collapse.vue?vue&type=style&index=0&id=483c8282&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-483c8282"

export default script